import cn from '@/lib/clsxm';
import Container from '@/components/@base/container';
import { SIZE_ENUM } from '@/components/@base/@types';
import type { FC } from 'react';
import type Props from '@/components/@base/input/radio/circular/type';

const Circular: FC<Props> = ({
   children,
   className,
   circulCalssName,
   size = SIZE_ENUM.MD,
   checked,
 }) => {
  return (
    <Container center className={cn('cursor-pointer justify-start gap-2.5', className)}>
      {/* Visual radio ONLY */}
      <span
        className={cn(
          'flex h-5 w-5 items-center justify-center rounded-full border-2 border-black transition-colors dark:border-white',
          checked ? 'bg-black dark:bg-white' : 'bg-transparent',
          circulCalssName
        )}
      >
        <span
          className={cn(
            'h-2.5 w-2.5 rounded-full bg-white transition-opacity dark:bg-grayLight-990',
            checked ? 'opacity-100' : 'opacity-0'
          )}
        />
      </span>

      {children && <span className="flex-1">{children}</span>}
    </Container>
  );
};

export default Circular;
